export default __webpack_public_path__ + "static/media/img6.74c9e043.png";